import type { CSSProperties } from 'react';

interface GrainMotifProps {
  /** «seed» — зёрнышко (вертикальная вика/полуовал); «ear» — дуга колоса из трёх зёрен. */
  readonly variant?: 'seed' | 'ear';
  readonly size?: number;
  /** CSS-цвет заливки; по умолчанию очень светлый брендовый. */
  readonly color?: string;
  /** Абсолютное позиционирование внутри секции (секция должна иметь position:relative + overflow:hidden). */
  readonly style?: CSSProperties;
}

// Фирменный водяной мотив «зерно» — единственная фоновая графика сайта (системно, не конфетти).
// Едва заметные крупные формы на фоне секций лендинга и пустых состояний кабинета.
// Декоративный: aria-hidden, не ловит клики, не влияет на layout (absolute).
export default function GrainMotif({
  variant = 'seed',
  size = 280,
  color = 'var(--mantine-color-brand-1)',
  style,
}: GrainMotifProps) {
  return (
    <svg
      aria-hidden
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      style={{ position: 'absolute', pointerEvents: 'none', userSelect: 'none', ...style }}
    >
      {variant === 'seed' ? (
        // Зёрнышко: вика (пересечение двух дуг), как зерно пшеницы в разрезе.
        <path d="M50 4 C72 26 72 74 50 96 C28 74 28 26 50 4 Z" fill={color} />
      ) : (
        // Дуга колоса: три зерна по диагонали с лёгким разворотом.
        <g fill={color}>
          <path d="M24 76 C36 88 36 100 24 100 C12 100 12 88 24 76 Z" transform="rotate(-30 24 88)" />
          <path d="M48 48 C60 60 60 72 48 72 C36 72 36 60 48 48 Z" transform="rotate(-30 48 60)" />
          <path d="M72 20 C84 32 84 44 72 44 C60 44 60 32 72 20 Z" transform="rotate(-30 72 32)" />
        </g>
      )}
    </svg>
  );
}
